import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {MatDialogRef} from '@angular/material/dialog';
import {map} from 'rxjs/operators';
import {TypesFormComponent} from '../../admin/medication-types/types-form/types-form.component';
import {MatDialog} from '@angular/material/dialog';
import {AppMatAutocompleteComponent} from '@xmedical/ui';
import {Medication, MedicationRepositoryService, MedicationType} from '@xmedical/core';

@Component({
    selector: 'app-medication-item-add-card',
    templateUrl: './medication-item-add-card.component.html',
    styleUrls: ['./medication-item-add-card.component.scss'],
    standalone: false
})
export class MedicationItemAddCardComponent implements OnInit, OnDestroy {

  validate = false;
  form: UntypedFormGroup;
  medicationType: MedicationType = null;
  @ViewChild(AppMatAutocompleteComponent) autocomplete: AppMatAutocompleteComponent;
  private repositorySubscription: Subscription;

  constructor(
    private dialogRef: MatDialogRef<MedicationItemAddCardComponent>,
    private dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private medicationRepository: MedicationRepositoryService) {
  }

  get hasType(): boolean {
    return this.form?.get('typeId').value !== null;
  }

  searchMedicationTypes$ = (query: string): Observable<MedicationType[]> => {
    return this.medicationRepository.queryTypes(query)
      .pipe(map(response => response));
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      description: ['', Validators.required],
      dosage: ['', Validators.required],
      diagnosisCode: ['', Validators.required],
      typeId: [null],
      comment: [''],
      textColour: ['']
    });
  }

  ngOnDestroy(): void {
    if (this.repositorySubscription) {
      this.repositorySubscription.unsubscribe();
    }
  }

  save() {
    if (this.form.valid) {
      const medication = this.formToMedication();
      this.repositorySubscription = this.medicationRepository.createMedicationItem(medication).subscribe(result => {
        this.dialogRef.close(medication);
      });
    }
    this.validate = true;
  }

  close() {
    this.dialogRef.close();
  }

  typeSelected(medicationType: MedicationType) {
    this.medicationType = medicationType;
    this.form.get('typeId').patchValue(medicationType.id);
    this.form.updateValueAndValidity();
    this.autocomplete.cancelSearch();
  }

  addNewType() {
    const DialogRef = this.dialog.open(TypesFormComponent, {panelClass: 'mat-confirmation-dialog-responsive'});
  }

  clearType() {
    this.form.get('typeId').setValue(null);
    this.form.updateValueAndValidity();
  }

  private formToMedication(): Medication {
    return this.form.value as Medication;
  }
}
